import api from "../utils/api";

const data = (response) => response?.data;

export const listAgreements = async (matterUuid) => data(await api.get(`/agreements/matter/${matterUuid}`));
export const getAgreementTypes = async () => data(await api.get("/agreements/types"));
export const createAgreement = async (values) => data(await api.post("/agreements", values));
export const getAgreement = async (uuid) => data(await api.get(`/agreements/i/${uuid}`));
export const updateAgreement = async (uuid, values) => data(await api.patch(`/agreements/i/${uuid}`, values));
export const deleteAgreement = async (uuid) => data(await api.delete(`/agreements/i/${uuid}`));
export const getAgreementContext = async (uuid) => data(await api.get(`/agreements/i/${uuid}/context`));
export const getAgreementVersions = async (uuid) => data(await api.get(`/agreements/i/${uuid}/versions`));
export const getAgreementAudit = async (uuid) => data(await api.get(`/agreements/i/${uuid}/audit`));
export const getAgreementArtifacts = async (uuid) => data(await api.get(`/agreements/i/${uuid}/artifacts`));
export const getAgreementLibrary = async ({ matterUuid, categoryUuid }) => data(await api.get("/agreements/provision-library", { params: { matterUuid, categoryUuid } }));
export const addAgreementLibraryProvision = async (values) => data(await api.post("/agreements/provision-library", values));
export const approveAgreementLibraryVersion = async (templateUuid, versionUuid) => data(await api.post(`/agreements/provision-library/${templateUuid}/versions/${versionUuid}/approve`));
export const customizeAgreementProvision = async (uuid, values) => data(await api.post(`/agreements/i/${uuid}/ai/customize`, values));
export const finalizeAgreement = async (uuid, values = {}) => data(await api.post(`/agreements/i/${uuid}/finalize`, values));

export async function downloadAgreementArtifact(agreementUuid, artifact) {
  const response = await api.get(`/agreements/i/${agreementUuid}/artifacts/${artifact.uuid}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = artifact.name || "Agreement.docx";
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
